import React, { useState } from "react";
// --- 1. Import useNavigate จาก react-router-dom ---
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import { faEye, faEyeSlash, faUser, faLock, faCircleNotch } from "@fortawesome/free-solid-svg-icons"; 
import { db } from "../Firebase";
import { collection, query, getDocs, where } from "firebase/firestore";

const Login = ({ onLoginSuccess }) => {
  // --- 2. เรียกใช้ hook เพื่อให้ได้ฟังก์ชัน navigate ---
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({ username: false, password: false });
  const [showPassword, setShowPassword] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target; 
    const processedValue = name === "username" ? value.toLowerCase() : value;
    setFormData({ ...formData, [name]: processedValue });
    setErrors({ ...errors, [name]: false });
    setLoginStatus(""); 
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const getStatusClass = (status) => {
    if (!status) return "";
    if (status.includes("กำลังตรวจสอบ") || status.includes("ตรวจสอบ...")) return "loading";
    if (status.toLowerCase().includes("success") || status.includes("สำเร็จ")) return "success";
    return "error";
  };

  const validate = () => {
    let isValid = true; 
    const newErrors = { username: false, password: false }; 
    if (!formData.username.trim()) {
      newErrors.username = true; 
      isValid = false; 
    }
    if (!formData.password.trim()) {
      newErrors.password = true; 
      isValid = false; 
    }
    setErrors(newErrors); 
    return isValid; 
  };

  const handleSubmit = async (e) => { 
    e.preventDefault(); 
    if (validate()) {
      setLoginStatus("กำลังตรวจสอบ...");
      try {
        const enteredUsernameTrimmedLower = formData.username.trim().toLowerCase();
        const enteredPasswordTrimmedLower = formData.password.trim().toLowerCase();

        // 1. ค้นหาเอกสารที่มีฟิลด์ username ตรงกับค่าที่กรอกเข้ามา (ใช้ where เพื่อความปลอดภัยและรวดเร็ว)
        const q = query(
          collection(db, "Admin"), 
          where("username", "==", enteredUsernameTrimmedLower)
        );
        const querySnapshot = await getDocs(q);
        
        let userFound = false; 

        for (const doc of querySnapshot.docs) {
          const userData = doc.data();
          userFound = true; 
          
          const dbPasswordTrimmedLower = userData.password ? userData.password.trim().toLowerCase() : '';
          
          if (enteredPasswordTrimmedLower === dbPasswordTrimmedLower) {
            setLoginStatus("Login successful"); 
            if (onLoginSuccess) {
              onLoginSuccess(userData); 
            }
            navigate('/main');
          } else {
            setLoginStatus("username or password not correct");
          }
          return;
        }

        if (!userFound) {
          setLoginStatus("username or password not correct"); 
        }
      } catch (error) {
        console.error("Error during login:", error);
        setLoginStatus("เกิดข้อผิดพลาดในการ Login"); 
      }
    } else {
      setLoginStatus("กรุณากรอกข้อมูลให้ครบถ้วน"); 
    }
  };

  return (
    <div className="login-container">
      {/* Dynamic Background Glass Blobs */}
      <div className="decor-blob blob-1"></div>
      <div className="decor-blob blob-2"></div>
      <div className="decor-blob blob-3"></div>

      <div className="login-box">
        <div className="login-icon">
          <img src="/Wisdom-Logo.png" alt="Wisdom Logo" /> 
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Administrator Login</h2>
          <p className="subtitle">ลงชื่อเข้าใช้งานระบบจัดการภายใน Wisdom Office</p>
          
          <div className={`input-group ${errors.username ? "alert-validate" : ""}`}>
            <input
              type="text" 
              className="input100" 
              name="username" 
              placeholder="Username" 
              value={formData.username} 
              onChange={handleChange} 
            />
            <span className="input-icon">
              <FontAwesomeIcon icon={faUser} />
            </span>
          </div>

          <div className={`input-group ${errors.password ? "alert-validate" : ""}`}>
            <input
              type={showPassword ? "text" : "password"} 
              className="input100" 
              name="password" 
              placeholder="Password" 
              value={formData.password} 
              onChange={handleChange} 
            />
            <span className="input-icon">
              <FontAwesomeIcon icon={faLock} />
            </span>
            <span className="password-toggle" onClick={togglePasswordVisibility}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loginStatus && (loginStatus.includes("กำลังตรวจสอบ") || loginStatus.includes("ตรวจสอบ..."))}
          >
            {loginStatus && (loginStatus.includes("กำลังตรวจสอบ") || loginStatus.includes("ตรวจสอบ...")) ? (
              <>
                <FontAwesomeIcon icon={faCircleNotch} spin style={{ marginRight: '8px' }} />
                กำลังตรวจสอบ...
              </>
            ) : "Login"}
          </button>

          {loginStatus && (
            <div className={`status-message ${getStatusClass(loginStatus)}`}>
              {getStatusClass(loginStatus) === "loading" && (
                <FontAwesomeIcon icon={faCircleNotch} spin style={{ marginRight: '8px' }} />
              )}
              {loginStatus}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;
